import React from 'react';

import { TaskCompletionOptions } from 'types/residents';

import { Selector } from 'components/Shared/Selector';

import { TaskDetails } from '../TaskDetails';
import { TaskRowContainer } from '../TaskRowContainer';

import { TaskOptions } from './TaskOptions';

type Props = {
    taskName: string;
    taskTime: string;
    taskNotes: string;
    taskCompletionOptions?: TaskCompletionOptions;
    isSelected?: boolean;
    completionOptionValue?: number;
    userTaskNotes?: string;
    onToggle?: () => void;
    onToggleNotes: () => void;
    onToggleEditAddTaskNotes: () => void;
    onToggleRejectDialog: () => void;
    onCompletionOptionsChange: (number) => void;
    onConfirmTask: () => void;
};

export const ResidentRowTask = (props: Props) => {
    const {
        taskName,
        taskTime,
        taskNotes,
        taskCompletionOptions,
        isSelected,
        completionOptionValue,
        userTaskNotes,
        onToggle,
        onToggleNotes,
        onToggleEditAddTaskNotes,
        onToggleRejectDialog,
        onCompletionOptionsChange,
        onConfirmTask,
    } = props;

    return (
        <TaskRowContainer>
            {onToggle && (
                <Selector isSelected={isSelected!} onSelect={onToggle} />
            )}
            <TaskDetails
                taskName={taskName}
                taskTime={taskTime}
                taskNotes={taskNotes}
                userTaskNotes={userTaskNotes}
                taskCompletionOptions={taskCompletionOptions}
                onToggleNotes={onToggleNotes}
                onToggleEditAddTaskNotes={onToggleEditAddTaskNotes}
                onCompletionOptionsChange={onCompletionOptionsChange}
                completionOptionValue={completionOptionValue}
            />
            <TaskOptions
                onToggleRejectDialog={onToggleRejectDialog}
                onConfirmTask={onConfirmTask}
            />
        </TaskRowContainer>
    );
};
